///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export class GtthNotificationMessage {
    id: number;
    text: string;
    styleClass: string;

    constructor(id: number, text: string, styleClass: string) {
        this.id = id;
        this.text = text;
        this.styleClass = styleClass;
    }
}

export class CustomConfirmationAction {
    text: string;
    closeWindowAfterAction = true;
    callback: () => void;
}

export class GtthConfirmationMessage extends GtthNotificationMessage {
    confirmActionText: string;
    declineActionText: string;
    customActions: CustomConfirmationAction[];

    constructor(id: number, text: string, styleClass: string, confirmActionText: string, declineActionText: string) {
        super(id, text, styleClass);
        this.confirmActionText = confirmActionText;
        this.declineActionText = declineActionText;
    }

    onConfirmResult(_userDecision: boolean): any {
        // do nothing by default
    }
}
